import { Tooltip } from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircleInfo } from "../Icons";

function TooltipComponent({ name, tooltipDescription }) {
  return (
    <>
      <FontAwesomeIcon
        data-tooltip-id={`${name}-info-tooltip`}
        data-tooltip-place="bottom"
        className="cursor-pointer ms-2"
        size="lg"
        icon={CircleInfo}
      />
      <Tooltip
        className="w-50"
        id={`${name}-info-tooltip`}
        openOnClick={true}
        multiline={true}
      >
        {tooltipDescription}
      </Tooltip>
    </>
  );
}

export default TooltipComponent;
